import { notification } from 'antd';

const notificationUtils = {
    success(msg) {
        notification.success({ duration: 2, message: msg });
    },
};

export default notificationUtils;
